import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  OnDestroy,
  signal,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';

import { ProjectModel } from '@core/models/project.model';
import * as fromRoot from '@core/redux/index';
import * as PopupAction from '@core/redux/popup/popup.actions';
import * as ProjectAction from '@core/redux/project/project.actions';
import { Store } from '@ngrx/store';
import { NgClickOutsideAttachOutsideDirective } from 'ng-click-outside2';

import { SelectColorComponent } from '../select-color/select-color.component';

@Component({
  selector: 'app-project-form',
  templateUrl: './project-form.component.html',
  styleUrls: ['./project-form.component.less'],
  imports: [SelectColorComponent, FormsModule, NgClickOutsideAttachOutsideDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectFormComponent implements OnDestroy, AfterViewInit {
  private store = inject(Store<fromRoot.State>);
  @ViewChild('nameInput') nameInput!: ElementRef<HTMLInputElement>;

  // Store signals
  selectedProject = toSignal(this.store.select(fromRoot.getProjectSelectedEntityForUpdate), { initialValue: null });
  parentId = toSignal(this.store.select(fromRoot.getProjectParentId), { initialValue: null });
  isSending = toSignal(this.store.select(fromRoot.getProjectLoading), { initialValue: false });

  // Form state
  formState = signal<ProjectModel>(new ProjectModel());

  constructor() {
    // Update form when source data changes
    effect(() => {
      const selected = this.selectedProject();
      const parent = this.parentId();

      if (selected) {
        this.formState.set(new ProjectModel().setAttributes(selected));
      } else if (parent) {
        const newModel = new ProjectModel();
        newModel.parentId = parent;
        this.formState.set(newModel);
      } else {
        this.formState.set(new ProjectModel());
      }

      // Focus the input after data changes
      setTimeout(() => this.focusNameInput());
    });
  }

  ngOnDestroy() {
    this.store.dispatch(new ProjectAction.SelectUpdateAction(null));
    this.store.dispatch(new ProjectAction.SetParentId(null));
  }

  ngAfterViewInit() {
    this.focusNameInput();
  }

  private focusNameInput() {
    if (this.nameInput?.nativeElement) {
      this.nameInput.nativeElement.focus();

      // Установка курсора в конец строки
      const inputValue = this.nameInput.nativeElement.value;
      this.nameInput.nativeElement.setSelectionRange(inputValue.length, inputValue.length);
    }
  }

  onClose = () => this.store.dispatch(new PopupAction.CloseProjectFormMenu());

  onSubmit = () => {
    const model = this.formState();
    this.store.dispatch(
      model.id !== undefined ? new ProjectAction.SaveAction(model) : new ProjectAction.CreateAction(model)
    );
  };

  onChangeColor = (color: string) => {
    this.formState.update(model =>
      new ProjectModel().setAttributes({
        ...model,
        color,
      })
    );
  };
}
